/**
 * @file HistoryFilter
 */

'use strict';
import Common from '../../Utils/Common';

/**
 * @classname HistoryFilter
 * @classdesc 変更履歴絞り込み
 */
export default class HistoryFilter {
	/**
	 * @constructor
	 * @param {jQuery} $e - #history-filter
	 */
	constructor($e) {
		console.log(`HistoryFilter.constructor`);
		this._$e = $e;
		$e.on('click', () => this.onClick());
	}


	/**
	 * clickのコールバック
	 *
	 * @memberof HistoryFilter
	 * @return {undefined}
	 */
	onClick() {
		console.log(`HistoryFilter.onClick`);
		const $infoMsg = $('.block-table-control .text span');
		$infoMsg.hide();
		const $tr = $('.tbody .tr');

		// どれも選ばれていない時の処理
		const selectedStatus = $('#status').val() || null;
		const selectedChangedColumn = $('#changed_column').val() || null;
		let from = $('#from').val() || null;
		let to = $('#to').val() || null;
		if (!selectedStatus && !selectedChangedColumn && !from && !to) {
			$tr.show();
			$('.tr-no-result').remove();
			$infoMsg.show();
			return;
		}

		// 絞り込み開始
		$tr.hide();

		// 状態確認
		let arr0 = [];
		$('.tbody .status').each((idx, e) => {
			const $e = $(e);
			const status = $e.text();
			if (status === selectedStatus) arr0.push(idx);
		})

		// 変更箇所確認
		let arr1 = [];
		$tr.each((idx, e) => {
			const $e = $(e);
			if(selectedChangedColumn && selectedChangedColumn !== '') {
				let changedColumn = $e.attr('data-changed-column');
				if(changedColumn && changedColumn !== '') {
					let changedColumnArray = changedColumn.split('|');
					console.log(changedColumnArray);
					for (let i = 0; i < changedColumnArray.length; i++) {
						if (selectedChangedColumn === changedColumnArray[i]) {
							arr1.push(idx);
						}
					}
				}
			}
		})

		// from to 確認
		const trLength = $tr.length;
		let arr2 = [];
		const now = new Date();
		const year = now.getFullYear();
		const month = now.getMonth() + 1;
		const day = now.getDate();
		const nowStr = `${year}-${Common.zeroPadding(month, 2)}-${Common.zeroPadding(day, 2)}`
		let from2, to2;
		if (!from) {
			from2 = '1900-01-01';
		} else {
			from2 = from
		}
		if(!to) {
			to2 = nowStr;
		} else {
			to2 = to
		}
		console.log(from2);
		console.log(to2);
		$tr.each((idx2, e2) => {
			const $e = $(e2);
			let changedDate = $e.find('.changed-date').text();
			console.log(changedDate);
			changedDate = changedDate.replace(/\//ig, '-');
			console.log(changedDate);
			if (from2 <= changedDate && to2 >= changedDate) {
				arr2.push(idx2);
			}
		})
		if(trLength === arr2.length) arr2 = [];

		console.log(arr0);
		console.log(arr1);
		console.log(arr2);


		// 重複している値の配列を作成
		let finalArr = [];
		if(selectedStatus && !selectedChangedColumn && !from && !to) {
			console.log('select status only')
			// 状態のみ選択
			finalArr = arr0;
		} else if (!selectedStatus && selectedChangedColumn && !from && !to) {
			console.log('select changed only')
			// 変更箇所のみ選択
			finalArr = arr1;
		} else if (!selectedStatus && !selectedChangedColumn && (from || to)) {
			console.log('select period only')
			// 期日のみ選択
			finalArr = arr2;
		} else if (selectedStatus && selectedChangedColumn && !from && !to) {
			console.log('select status & changed')
			// 状態と変更箇所を選択
			if (arr0.length > 0 && arr1.length > 0) {
				console.log('get duplicated');
				finalArr = this.getMergedArray(arr0, arr1);
			} else {
				console.log('no match');
				finalArr = [];
			}
		} else if (selectedStatus && !selectedChangedColumn && (from || to)) {
			console.log('select status & period')
			// 状態と期日を選択
			if (arr0.length > 0 && arr2.length > 0) {
				console.log('get duplicated')
				finalArr = this.getMergedArray(arr0, arr2);
			} else {
				console.log('no match');
				finalArr = [];
			}
		} else if (selectedStatus && !selectedChangedColumn && (from || to)) {
			console.log('select changed & period')
			// 状態と期日を選択
			if (arr1.length > 0 && arr2.length > 0) {
				console.log('get duplicated')
				finalArr = this.getMergedArray(arr1, arr2);
			} else {
				console.log('no match');
				finalArr = [];
			}
		} else if (selectedStatus && selectedChangedColumn && (from || to)) {
			console.log('select changed & period')
			// 全てを選択
			let tmpArr = [];
			if (arr0.length > 0 && arr1.length > 0) {
				console.log('get tmp duplicated')
				tmpArr = this.getMergedArray(arr0, arr1);
			} else {
				console.log('no match');
				tmpArr = [];
			}
			if (tmpArr.length > 1 && arr2.length > 0) {
				console.log('get duplicated')
				finalArr = this.getMergedArray(empArr, arr2);
			} else {
				console.log('no match');
				finalArr = [];
			}
		}
		console.log(finalArr);

		// 該当を表示
		if(finalArr.length === 0) {
			let noResultTr = `<tr class="tr tr-no-result"><td class="td" colspan="68"><span>&nbsp;</span></td></tr>`;
			$('.tbody').append(noResultTr);
		} else {
			for (let j = 0; j < finalArr.length; j++) {
				$tr.eq(finalArr[j]).show();
			}
		}

	};


	/**
	 * 配列の重複を取り出す
	 *
	 * @memberof HistoryFilter
	 * @return {undefined}
	 */
	getMergedArray(arr1, arr2) {
		const arr1arr2 = [...arr1, ...arr2];
		const duplicatedArr = arr1arr2.filter(
			item => arr1.includes(item) && arr2.includes(item)
		);
		const mergedArr = [...new Set(duplicatedArr)];
		return mergedArr;
	}
}
